export default {
    zh: {
        wan26: 'Wan 2.6',
        gptImage15: 'GPT Image 1.5',
        weryAIImage2: 'WeryAI Image 2.0',
        weryAIImage1: 'WeryAI Image 1.0',
        recraftV4: 'Recraft V4',
        recraftV4Desc: '专业级图像生成，高质量视觉创作',
        recraftV4Pro: 'Recraft V4 Pro',
        recraftV4ProDesc: '增强版图像生成，更精准的创作控制',
        recraftV4ProVector: 'Recraft V4 Pro Vector',
        recraftV4ProVectorDesc: '专业矢量图生成，可编辑的 SVG 输出',
        imagePromptInversionTitle: '提示词反推器',
        imagePromptInversionDesc: '上传图片，AI 自动为您生成它的 Prompt',
    },
    en: {
        wan26: 'Wan 2.6',
        gptImage15: 'GPT Image 1.5',
        weryAIImage2: 'WeryAI Image 2.0',
        weryAIImage1: 'WeryAI Image 1.0',
        recraftV4: 'Recraft V4',
        recraftV4Desc: 'Professional image generation, high-quality visual creation',
        recraftV4Pro: 'Recraft V4 Pro',
        recraftV4ProDesc: 'Enhanced image generation with precise creative control',
        recraftV4ProVector: 'Recraft V4 Pro Vector',
        recraftV4ProVectorDesc: 'Professional vector generation with editable SVG output',
        imagePromptInversionTitle: 'Image Prompt Inversion',
        imagePromptInversionDesc: 'Upload an image, AI automatically generates its Prompt for you',
    },
    ja: {
        wan26: 'Wan 2.6',
        gptImage15: 'GPT Image 1.5',
        weryAIImage2: 'WeryAI Image 2.0',
        weryAIImage1: 'WeryAI Image 1.0',
        recraftV4: 'Recraft V4',
        recraftV4Desc: 'プロフェッショナルな画像生成、高品質なビジュアル作成',
        recraftV4Pro: 'Recraft V4 Pro',
        recraftV4ProDesc: '強化された画像生成、より精密なクリエイティブコントロール',
        recraftV4ProVector: 'Recraft V4 Pro Vector',
        recraftV4ProVectorDesc: 'プロフェッショナルなベクター生成、編集可能なSVG出力',
        imagePromptInversionTitle: 'イメージプロンプト反転',
        imagePromptInversionDesc: '画像をアップロードすると、AIが自動的にプロンプトを生成します',
    },
    ko: {
        wan26: 'Wan 2.6',
        gptImage15: 'GPT Image 1.5',
        weryAIImage2: 'WeryAI Image 2.0',
        weryAIImage1: 'WeryAI Image 1.0',
        recraftV4: 'Recraft V4',
        recraftV4Desc: '전문적인 이미지 생성, 고품질 비주얼 제작',
        recraftV4Pro: 'Recraft V4 Pro',
        recraftV4ProDesc: '향상된 이미지 생성, 더 정밀한 크리에이티브 제어',
        recraftV4ProVector: 'Recraft V4 Pro Vector',
        recraftV4ProVectorDesc: '전문 벡터 생성, 편집 가능한 SVG 출력',
        imagePromptInversionTitle: '이미지 프롬프트 반전',
        imagePromptInversionDesc: '이미지를 업로드하면 AI가 자동으로 프롬프트를 생성해 드립니다',
    },
    es: {
        wan26: 'Wan 2.6',
        gptImage15: 'GPT Image 1.5',
        weryAIImage2: 'WeryAI Image 2.0',
        weryAIImage1: 'WeryAI Image 1.0',
        recraftV4: 'Recraft V4',
        recraftV4Desc: 'Generación profesional de imágenes, creación visual de alta calidad',
        recraftV4Pro: 'Recraft V4 Pro',
        recraftV4ProDesc: 'Generación mejorada de imágenes con control creativo preciso',
        recraftV4ProVector: 'Recraft V4 Pro Vector',
        recraftV4ProVectorDesc: 'Generación profesional de vectores con salida SVG editable',
        imagePromptInversionTitle: 'Inversión de Prompt de Imagen',
        imagePromptInversionDesc: 'Sube una imagen, la IA generará automáticamente su Prompt por ti',
    },
    fr: {
        wan26: 'Wan 2.6',
        gptImage15: 'GPT Image 1.5',
        weryAIImage2: 'WeryAI Image 2.0',
        weryAIImage1: 'WeryAI Image 1.0',
        recraftV4: 'Recraft V4',
        recraftV4Desc: 'Génération d\'images professionnelle, création visuelle de haute qualité',
        recraftV4Pro: 'Recraft V4 Pro',
        recraftV4ProDesc: 'Génération d\'images améliorée avec contrôle créatif précis',
        recraftV4ProVector: 'Recraft V4 Pro Vector',
        recraftV4ProVectorDesc: 'Génération de vecteurs professionnelle avec sortie SVG éditable',
        imagePromptInversionTitle: 'Inversion de Prompt d\'Image',
        imagePromptInversionDesc: 'Téléchargez une image, l\'IA générera automatiquement son Prompt pour vous',
    },
    de: {
        wan26: 'Wan 2.6',
        gptImage15: 'GPT Image 1.5',
        weryAIImage2: 'WeryAI Image 2.0',
        weryAIImage1: 'WeryAI Image 1.0',
        recraftV4: 'Recraft V4',
        recraftV4Desc: 'Professionelle Bildgenerierung, hochwertige visuelle Erstellung',
        recraftV4Pro: 'Recraft V4 Pro',
        recraftV4ProDesc: 'Erweiterte Bildgenerierung mit präziser kreativer Kontrolle',
        recraftV4ProVector: 'Recraft V4 Pro Vector',
        recraftV4ProVectorDesc: 'Professionelle Vektorgenerierung mit bearbeitbarer SVG-Ausgabe',
        imagePromptInversionTitle: 'Bild-Prompt-Inversion',
        imagePromptInversionDesc: 'Laden Sie ein Bild hoch, die KI generiert automatisch den passenden Prompt für Sie',
    },
    ru: {
        wan26: 'Wan 2.6',
        gptImage15: 'GPT Image 1.5',
        weryAIImage2: 'WeryAI Image 2.0',
        weryAIImage1: 'WeryAI Image 1.0',
        recraftV4: 'Recraft V4',
        recraftV4Desc: 'Профессиональная генерация изображений, высококачественное визуальное создание',
        recraftV4Pro: 'Recraft V4 Pro',
        recraftV4ProDesc: 'Улучшенная генерация изображений с точным творческим контролем',
        recraftV4ProVector: 'Recraft V4 Pro Vector',
        recraftV4ProVectorDesc: 'Профессиональная генерация векторов с редактируемым SVG выводом',
        imagePromptInversionTitle: 'Инверсия Промпта Изображения',
        imagePromptInversionDesc: 'Загрузите изображение, ИИ автоматически сгенерирует для него Промпт',
    },
    pt: {
        wan26: 'Wan 2.6',
        gptImage15: 'GPT Image 1.5',
        weryAIImage2: 'WeryAI Image 2.0',
        weryAIImage1: 'WeryAI Image 1.0',
        recraftV4: 'Recraft V4',
        recraftV4Desc: 'Geração profissional de imagens, criação visual de alta qualidade',
        recraftV4Pro: 'Recraft V4 Pro',
        recraftV4ProDesc: 'Geração aprimorada de imagens com controle criativo preciso',
        recraftV4ProVector: 'Recraft V4 Pro Vector',
        recraftV4ProVectorDesc: 'Geração profissional de vetores com saída SVG editável',
        imagePromptInversionTitle: 'Inversão de Prompt de Imagem',
        imagePromptInversionDesc: 'Carregue uma imagem, a IA gerará automaticamente o Prompt para você',
    },
    it: {
        wan26: 'Wan 2.6',
        gptImage15: 'GPT Image 1.5',
        weryAIImage2: 'WeryAI Image 2.0',
        weryAIImage1: 'WeryAI Image 1.0',
        recraftV4: 'Recraft V4',
        recraftV4Desc: 'Generazione professionale di immagini, creazione visiva di alta qualità',
        recraftV4Pro: 'Recraft V4 Pro',
        recraftV4ProDesc: 'Generazione migliorata di immagini con controllo creativo preciso',
        recraftV4ProVector: 'Recraft V4 Pro Vector',
        recraftV4ProVectorDesc: 'Generazione professionale di vettori con output SVG modificabile',
        imagePromptInversionTitle: 'Inversione del Prompt dell\'Immagine',
        imagePromptInversionDesc: 'Carica un\'immagine, l\'IA genererà automaticamente il relativo Prompt per te',
    },
    ar: {
        wan26: 'Wan 2.6',
        gptImage15: 'GPT Image 1.5',
        weryAIImage2: 'WeryAI Image 2.0',
        weryAIImage1: 'WeryAI Image 1.0',
        recraftV4: 'Recraft V4',
        recraftV4Desc: 'توليد صور احترافي، إنشاء بصري عالي الجودة',
        recraftV4Pro: 'Recraft V4 Pro',
        recraftV4ProDesc: 'توليد صور محسّن مع تحكم إبداعي دقيق',
        recraftV4ProVector: 'Recraft V4 Pro Vector',
        recraftV4ProVectorDesc: 'توليد متجهات احترافي مع مخرجات SVG قابلة للتحرير',
        imagePromptInversionTitle: 'عكس موجه الصورة',
        imagePromptInversionDesc: 'قم بتحميل صورة، وسيقوم الذكاء الاصطناعي بتوليد الموجه (Prompt) الخاص بها تلقائيًا',
    },
    tw: {
        wan26: 'Wan 2.6',
        gptImage15: 'GPT Image 1.5',
        weryAIImage2: 'WeryAI Image 2.0',
        weryAIImage1: 'WeryAI Image 1.0',
        recraftV4: 'Recraft V4',
        recraftV4Desc: '專業級圖像生成，高品質視覺創作',
        recraftV4Pro: 'Recraft V4 Pro',
        recraftV4ProDesc: '增強版圖像生成，更精準的創作控制',
        recraftV4ProVector: 'Recraft V4 Pro Vector',
        recraftV4ProVectorDesc: '專業矢量圖生成，可編輯的 SVG 輸出',
        imagePromptInversionTitle: '提示詞反推器',
        imagePromptInversionDesc: '上傳圖片，AI 自動為您生成它的 Prompt',
    },
    pl: {
        wan26: 'Wan 2.6',
        gptImage15: 'GPT Image 1.5',
        weryAIImage2: 'WeryAI Image 2.0',
        weryAIImage1: 'WeryAI Image 1.0',
        recraftV4: 'Recraft V4',
        recraftV4Desc: 'Profesjonalna generacja obrazów, wysokiej jakości tworzenie wizualne',
        recraftV4Pro: 'Recraft V4 Pro',
        recraftV4ProDesc: 'Ulepszona generacja obrazów z precyzyjną kontrolą kreatywną',
        recraftV4ProVector: 'Recraft V4 Pro Vector',
        recraftV4ProVectorDesc: 'Profesjonalna generacja wektorów z edytowalnym wyjściem SVG',
        imagePromptInversionTitle: 'Odwracanie Promptu Obrazu',
        imagePromptInversionDesc: 'Prześlij obraz, a sztuczna inteligencja automatycznie wygeneruje dla Ciebie prompt',
    },
    th: {
        wan26: 'Wan 2.6',
        gptImage15: 'GPT Image 1.5',
        weryAIImage2: 'WeryAI Image 2.0',
        weryAIImage1: 'WeryAI Image 1.0',
        recraftV4: 'Recraft V4',
        recraftV4Desc: 'การสร้างภาพระดับมืออาชีพ การสร้างภาพคุณภาพสูง',
        recraftV4Pro: 'Recraft V4 Pro',
        recraftV4ProDesc: 'การสร้างภาพที่ได้รับการปรับปรุง พร้อมการควบคุมเชิงสร้างสรรค์ที่แม่นยำ',
        recraftV4ProVector: 'Recraft V4 Pro Vector',
        recraftV4ProVectorDesc: 'การสร้างเวกเตอร์ระดับมืออาชีพ พร้อมผลลัพธ์ SVG ที่แก้ไขได้',
        imagePromptInversionTitle: 'การย้อนกลับพรอมต์รูปภาพ',
        imagePromptInversionDesc: 'อัปโหลดรูปภาพ AI จะสร้างพรอมต์ให้คุณโดยอัตโนมัติ',
    },
    da: {
        wan26: 'Wan 2.6',
        gptImage15: 'GPT Image 1.5',
        weryAIImage2: 'WeryAI Image 2.0',
        weryAIImage1: 'WeryAI Image 1.0',
        recraftV4: 'Recraft V4',
        recraftV4Desc: 'Professionel billedgenerering, visuel skabelse af høj kvalitet',
        recraftV4Pro: 'Recraft V4 Pro',
        recraftV4ProDesc: 'Forbedret billedgenerering med præcis kreativ kontrol',
        recraftV4ProVector: 'Recraft V4 Pro Vector',
        recraftV4ProVectorDesc: 'Professionel vektorgenerering med redigerbar SVG-output',
        imagePromptInversionTitle: 'Billed-Prompt-Inversion',
        imagePromptInversionDesc: 'Upload et billede, AI genererer automatisk prompten for dig',
    },
    no: {
        wan26: 'Wan 2.6',
        gptImage15: 'GPT Image 1.5',
        weryAIImage2: 'WeryAI Image 2.0',
        weryAIImage1: 'WeryAI Image 1.0',
        recraftV4: 'Recraft V4',
        recraftV4Desc: 'Profesjonell bildegenerering, visuell skaping av høy kvalitet',
        recraftV4Pro: 'Recraft V4 Pro',
        recraftV4ProDesc: 'Forbedret bildegenerering med presis kreativ kontroll',
        recraftV4ProVector: 'Recraft V4 Pro Vector',
        recraftV4ProVectorDesc: 'Profesjonell vektorgenerering med redigerbar SVG-utgang',
        imagePromptInversionTitle: 'Bilde-Prompt-Inversjon',
        imagePromptInversionDesc: 'Last opp et bilde, AI genererer automatisk prompten for deg',
    },
    nl: {
        wan26: 'Wan 2.6',
        gptImage15: 'GPT Image 1.5',
        weryAIImage2: 'WeryAI Image 2.0',
        weryAIImage1: 'WeryAI Image 1.0',
        recraftV4: 'Recraft V4',
        recraftV4Desc: 'Professionele beeldgeneratie, hoogwaardige visuele creatie',
        recraftV4Pro: 'Recraft V4 Pro',
        recraftV4ProDesc: 'Verbeterde beeldgeneratie met nauwkeurige creatieve controle',
        recraftV4ProVector: 'Recraft V4 Pro Vector',
        recraftV4ProVectorDesc: 'Professionele vectorgeneratie met bewerkbare SVG-output',
        imagePromptInversionTitle: 'Beeld-Prompt-Inversie',
        imagePromptInversionDesc: 'Upload een afbeelding, AI genereert automatisch de bijbehorende prompt voor u',
    },
    id: {
        wan26: 'Wan 2.6',
        gptImage15: 'GPT Image 1.5',
        weryAIImage2: 'WeryAI Image 2.0',
        weryAIImage1: 'WeryAI Image 1.0',
        recraftV4: 'Recraft V4',
        recraftV4Desc: 'Generasi gambar profesional, pembuatan visual berkualitas tinggi',
        recraftV4Pro: 'Recraft V4 Pro',
        recraftV4ProDesc: 'Generasi gambar yang ditingkatkan dengan kontrol kreatif yang presisi',
        recraftV4ProVector: 'Recraft V4 Pro Vector',
        recraftV4ProVectorDesc: 'Generasi vektor profesional dengan output SVG yang dapat diedit',
        imagePromptInversionTitle: 'Inversi Prompt Gambar',
        imagePromptInversionDesc: 'Unggah gambar, AI secara otomatis menghasilkan prompt-nya untuk Anda',
    },
    tr: {
        wan26: 'Wan 2.6',
        gptImage15: 'GPT Image 1.5',
        weryAIImage2: 'WeryAI Image 2.0',
        weryAIImage1: 'WeryAI Image 1.0',
        recraftV4: 'Recraft V4',
        recraftV4Desc: 'Profesyonel görüntü oluşturma, yüksek kaliteli görsel yaratım',
        recraftV4Pro: 'Recraft V4 Pro',
        recraftV4ProDesc: 'Hassas yaratıcı kontrol ile geliştirilmiş görüntü oluşturma',
        recraftV4ProVector: 'Recraft V4 Pro Vector',
        recraftV4ProVectorDesc: 'Düzenlenebilir SVG çıktısı ile profesyonel vektör oluşturma',
        imagePromptInversionTitle: 'Görüntü İstemi Tersine Çevirme',
        imagePromptInversionDesc: 'Bir resim yükleyin, yapay zeka sizin için otomatik olarak istemini (Prompt) oluştursun',
    },
}
